import React from 'react';
import { scopes as scopesTranlsation } from '../../classes/lib-common';

const ScoreNotUpdated = ({display})=>{
	return(
        display?
		<div className="report-box" id="score-not-updated">
            <div className="report-box-header gray">
                <span className="glyphicon glyphicon-retweet fa-fw"> </span>
                THE SCORE MAY NOT BE UP TO DATE
            </div>
            <div className="report-box-text">
                Since the report was built some vulnerabilities were mitigated, reported or marked as not applicable,
                and for that reason, the score might not be up to date. Please complete any other change and, when
                ready, kindly request an update of this report.<br/>
                <strong>Please note that unless the report is recomputed all the changes made are not persisted.</strong>
            </div>
        </div>
        :null
	)
}

const AllGood = ({display})=>{
	return(
        display?
		<div className="report-box" id="all-good">
            <div className="report-box-header">
                EVERYTHING LOOKS GOOD
            </div>
            <div className="report-box-text">
                Our analysis shows that at the moment this project code is not at risk of known security
                vulnerabilities or serious bugs in dependency libraries.
                However, we are always working hard to improve our system, so make sure you check this page
                frequently to get updates.<br/>
                In the meantime, why not looking at our<a href="https://blog.meterian.com" className="m-1">Blog</a>to see our
                latest news?
            </div>
        </div>
        :null
	)
}

const PartialBuild = ({display})=>{
	return(
        display?
		<div className="report-box" id="partial-build">
            <div className="report-box-header red">
                <span className="glyphicon glyphicon-alert fa-fw"> </span>
                WE ENCOUNTERED SOME ISSUES WITH THE BUILD
            </div>
            <div className="report-box-text">
                Our reporting engine has been able to scan this project and produce a report. However some
                errors during the build have been detected that could potentially make
                this report incomplete. Please check if your build works in your test environment. <br/>
                Don't esitate to contact us at<a href="mailto:support@meterian.com" className="m-1">support@meterian.com</a>if
                you need more information.
            </div>
        </div>
        :null
	)
}

const SecurityIssues = ({display, report, summary, collapsed}) =>{

    const {cwes, cves,  threats, fixable, notFixable, highestCvss} = summary.issues

    let threatMessages = [];
    if(threats.critical>0){
        threatMessages.push(threats.critical===1?"1 component with critical threat vulnerabilities":threats.critical+" components with critical threat vulnerabilities")
    }
    if(threats.high>0){
        threatMessages.push(threats.high===1?"1 component with high threat vulnerabilities":threats.high+" components with high threat vulnerabilities")
    }
    if(threats.medium>0){
        threatMessages.push(threats.medium===1?"1 component with medium threat vulnerabilities":threats.medium+" components with medium threat vulnerabilities")
    }
    if(threats.low>0){
        threatMessages.push(threats.low===1?"1 component with low threat vulnerabilities":threats.low+" components with low threat vulnerabilities")
    }
    if(threats.suggest>0){
        threatMessages.push(threats.suggest===1?"1 component with suggestions":threats.suggest+" components with suggestions")
    }
    if(threats.none>0){
        threatMessages.push(threats.none===1?"1 informational advice":threats.none+" components with informational advisories")
    }


    const mostCommonCwe = {cwe:"", instances:0, "numericId": ""}
    for(const cwe in cwes){
        if (cwe==="NO-CWE"){
            continue;
        }
        if (mostCommonCwe.instances < cwes[cwe]){
            mostCommonCwe.cwe=cwe
            mostCommonCwe.instances=cwes[cwe]
            mostCommonCwe.numericId = cwe.split("-")[1]
        }
    }

    const CweParagraph = ()=>(
        !mostCommonCwe.cwe.length?"":
        <li>
            The most common vulnerability detected is labelled as <a href={"https://cwe.mitre.org/data/definitions/"+mostCommonCwe.numericId} target="_blank" rel="noopener noreferrer">{mostCommonCwe.cwe}</a>, encountered {mostCommonCwe.instances===1?"1 time.":mostCommonCwe.instances+" times."}
        </li>
    )
    

    const mostCommonCve = {cve:"", instances:0}
    for(const cve in cves){
        if (cve==="N/A"){
            continue;
        }
        if (mostCommonCve.instances < cves[cve]){
            mostCommonCve.cve=cve
            mostCommonCve.instances=cves[cve]
        }
    }

    const CveParagraph = ()=>(
        !mostCommonCve.cve.length?"":
        <li>
            <a href={"https://nvd.nist.gov/vuln/detail/"+mostCommonCve.cve} target="_blank" rel="noopener noreferrer">{mostCommonCve.cve}</a>, found in {mostCommonCve.instances===1?"1 component":mostCommonCve.instances+" components"}, is the most recurrent CVE.
        </li>
    )

    if (!display) return ""

    const vulnerable = threats.critical + threats.high + threats.medium + threats.low 
    const otherThreats = threats.none + threats.suggest


    if (vulnerable > 0) 
        return collapsed ? 
            <li>{vulnerable} {vulnerable===1?"component contains":"components contain"} at least one vulnerability</li>
            :
            <div className="report-box" id="security-issues">
                <div className="report-box-header red">
                    <span className="glyphicon glyphicon-alert fa-fw"> </span>
                    SECURITY ISSUES
                </div>
                <div className="report-box-text">
                    Meterian detected {threatMessages.join(", ")}. {fixable>0?<React.Fragment>For {fixable} of these components, an update is available which mitigates the vulnerability.<br/></React.Fragment>:""}
                    {notFixable>0?<React.Fragment>For {notFixable} {notFixable===1?"component":"components"} there is currently no safe version. We highly recommend the use of alternative components.<br/></React.Fragment>:""}
                    <br/>
                    <ul>
                        {CveParagraph()}
                        <li>The highest vulnerability score overall is {highestCvss}</li>
                        {CweParagraph()}
                    </ul>
                </div>
            </div>

    if (otherThreats > 0)
        return collapsed?
            <li>{otherThreats} {otherThreats===1?"component contains":"components contain"} at least one suggestion or informational advice</li>
            :
            <div className="report-box" id="security-issues">
                <div className="report-box-header red">
                    <span className="glyphicon glyphicon-alert fa-fw"> </span>
                    SECURITY ISSUES
                </div>
                <div className="report-box-text">
                    Meterian detected {otherThreats > 1? (otherThreats + " components") : "1 component"} with at least one suggestion or informational advice.<br/>
                    {otherThreats > 1? "They" : "It"} can be displayed by switching on the "OTHER" filter from the Security Assessment.
                </div>
            </div>

    return <AllGood display={true}/>
	
}

const VersionUpdate= ({display, summary, collapsed})=>{

    let allMajors = 0
    let allMinors = 0
    let allPatches = 0

    for (const language in summary.byLanguage){
        allMajors+=summary.byLanguage[language].major;
        allMinors+=summary.byLanguage[language].minor;
        allPatches+=summary.byLanguage[language].patch;
    }

    const PatchesParagraph= ()=>{
        if (allPatches===0) return ""
        return(
            <li> {allPatches} {allPatches===1?"component is":"components are"} missing patches </li>
        )
    }

    const OutdateParagraph= ()=>{
        if (allMinors+allMajors===0) return ""
        return(
            <li> {allMinors+allMajors} {allMinors+allMajors===1?"component is":"components are"} out of date </li>
        )
    }

    if (!display) return ""
	return collapsed?
        <React.Fragment>
            {PatchesParagraph()}
            {OutdateParagraph()}
        </React.Fragment>
        :
		<div className="report-box" id="version-updates">
            <div className="report-box-header orange">
                <span className="glyphicon glyphicon-check fa-fw"> </span>
                STABILITY ISSUES
            </div>
            <div className="report-box-text">
                There is an update available for {allMajors+allMinors+allPatches} components used in this project.<br/>
                {allPatches>0?"Updating to the latest patch release could significantly improve the stability and performances of your application. We strongly recommend patching the affected components.":"We strongly recommend updating the affected components."}<br/><br/>
                <ul>
                    {PatchesParagraph()}
                    {OutdateParagraph()}
                </ul>
                
            </div>
        </div>
	
}

const LicenseIssues=({display, summary, collapsed})=>{

    let undeclared = 0
    let forbidden = 0


    for (const language in summary.byLanguage){
        forbidden+=summary.byLanguage[language].forbiddenWithoutExclusion;
        undeclared+=summary.byLanguage[language].undeclaredWithoutExclusion;
    }

    const UndeclaredParagraph = ()=>{
        if (undeclared===0){
            return ""
        }
        return(
            <li> {undeclared} {undeclared===1?"component":"components"} do not declare a license.</li>
        )
    }

    const ForbiddenParagraph = ()=>{
        if (forbidden===0){
            return ""
        }
        return(
            <li> {forbidden} {forbidden===1?"component is":"components are"} using a forbidden license, which might harm your business.</li>
        )
    }
    if (!display) return ""
    if (!forbidden && !undeclared) return null
	return collapsed?
        <React.Fragment>
            {ForbiddenParagraph()}
            {UndeclaredParagraph()}
        </React.Fragment>
        :
		<div className="report-box" id="licenses-issues">
            <div className="report-box-header red">
                <span className="glyphicon glyphicon-alert fa-fw"> </span>
                LICENSING ISSUES
            </div>
            <div className="report-box-text">
                There are {undeclared+forbidden} components to assess:<br/>
                We strongly advise you to <b>not ship</b> your software until such problem is resolved.<br/><br/>
                <ul>
                    {ForbiddenParagraph()}
                    {UndeclaredParagraph()}
                </ul>
            </div>
        </div>
}



class Actions extends React.Component{
    constructor(props){
        super(props)
        this.state={
            allGood: false
        }
    }
    componentDidMount(){
        if(this.state.sidebar){
            this.setState({allGood: true})
        }
    }
    render(){
        const { issues,  partialBuild, shouldShowLicenses, summary, report, collapsed}=this.props;
        const {securityReady, stabilityReady, licensingIssues, recomputeAvailable}=issues;

        const areThereNoIssues=Object.keys(issues).reduce((result,key)=>{
            if(issues[key]) result=false;
            return result
        },true)


        let totComponents = 0;
        for (let language in summary.security.byLanguage){
            totComponents += summary.security.byLanguage[language].components
        }

        
        
        return collapsed?
            <div>
                <AllGood display={areThereNoIssues}/>
                {!areThereNoIssues?
                    <div className="report-box w-100">
                        <div className="report-box-header red">
                            <span className="glyphicon glyphicon-alert fa-fw"> </span>
                            ISSUES SUMMARY
                        </div>
                        <div className="report-box-text">
                            {
                                collapsed?
                                    <li>{totComponents} {totComponents===1?"component has ":"components have "}been detected in this project</li>:
                                    ""
                            }
                            <SecurityIssues display={securityReady} summary = {summary.security} collapsed={true}/>
                            <VersionUpdate display={stabilityReady} summary = {summary.stability} collapsed={true}/>
                            <LicenseIssues display={licensingIssues && shouldShowLicenses} summary = {summary.licensing} collapsed={true}/>
                        </div>
                    </div>
                    : null
                }
            </div>
            :
            <div className="col-lg-8">
                <p></p>
                <ScoreNotUpdated display={recomputeAvailable} />
                <AllGood display={areThereNoIssues}/>
                <PartialBuild display={partialBuild} />
                <SecurityIssues display={securityReady} summary = {summary.security} report = {report.security}/>
                <VersionUpdate display={stabilityReady} summary = {summary.stability}/>
                <LicenseIssues display={licensingIssues && shouldShowLicenses} summary = {summary.licensing}/>
                
            </div>
    
        
    }
}











const SideBar=({display,timestamp,urlParams,summary,scopes})=>{

    const selectOrdinalIndicator=(day)=>{
        const ordinalIndicators=['th','st','nd','rd'];
        day=day.toString();
        const last=day[day.length-1];
        switch(last){
            case last>0 && last<=3: return ordinalIndicators[last];
            default: return ordinalIndicators[0];
        }
    }
    const timeFormat=(item)=>{
        item=item.toString();
        return item.length>1?item:"0"+item;
    }
    const getTimeString=(hours,minutes,seconds)=>{
        hours=timeFormat(hours);
        minutes=timeFormat(minutes);
        seconds=timeFormat(seconds);
        return `${hours}:${minutes}:${seconds}`
    }
    
    const processSummary = (summary)=>{
        const processed = {};
        for(const language in summary.licensing.byLanguage){
            if(!processed[language]) processed[language]={};
            const security = summary.security.byLanguage[language];
            const stability = summary.stability.byLanguage[language];
            const licensing = summary.licensing.byLanguage[language];
            if(security){
                processed[language].vulnerable = security.critical + security.high + security.medium + security.low + security.none + security.suggest + security.exclusions;
                processed[language].securityExclusions = security.exclusions;
                processed[language].securityCount=security.components
            }
            else{
                processed[language].vulnerable = null
                processed[language].securityCount=0
            }


            if(stability){
                processed[language].outdated = stability.patch+stability.minor+stability.major+stability.exclusions;
                processed[language].stabilityExclusions = stability.exclusions;
                processed[language].stabilityCount=stability.components

            }
            else{
                processed[language].outdated = null
                processed[language].stabilityCount=0
            }
            if(licensing){
                processed[language].components = licensing.tot;
                processed[language].undeclared = licensing.undeclared;
                processed[language].forbidden = licensing.forbidden;
                processed[language].warningExclusions = licensing.warningExclusions;
                processed[language].violationExclusions = licensing.violationExclusions;
                processed[language].licensingCount=licensing.components
                if(licensing.components) processed[language].components=0

            }
            else{
                processed[language].components = null
                processed[language].licensingCount=0
            }
        }

    
        return processed;
        
    }

    const Summary = ({summary})=>{
        return Object.keys(summary).map(language=>{
            if(summary[language].components===null) return ""

            const {vulnerable,outdated,undeclared,forbidden} = summary[language]

            const hasNoComponents = summary[language].securityCount===0 && summary[language].stabilityCount===0 && summary[language].licensingCount===0;
            const hasIssues = vulnerable>0 || outdated>0 || undeclared+forbidden>0
            return(
                <React.Fragment key={language}>
                    <b className="ml-3">{language}</b>
                    <br />
                    <ul className="d-none d-sm-block">
                        
                        { hasNoComponents && summary[language].components===0?
                            <li>0 components detected</li>:""
                        }

                        {   summary[language].vulnerable?
                                <li>Vulnerable: {summary[language].vulnerable}{summary[language].securityCount?"/"+summary[language].securityCount:""} 
                                    {summary[language].securityExclusions>0?<i className='opaque'>{"("+summary[language].securityExclusions+" excluded)"}</i>:""}

                                    </li>   
                                :""
                        }
                        {
                            summary[language].outdated?
                                <li>Outdated: {summary[language].outdated}{summary[language].stabilityCount?"/"+summary[language].stabilityCount:""} 
                                {summary[language].stabilityExclusions>0?<i className='opaque'>{"("+summary[language].stabilityExclusions+" excluded)"}</i>:""}</li>
                                :""
                        }
                        {
                            summary[language].forbidden || summary[language].undeclared?
                            <React.Fragment>
                                <li>With forbidden licenses: {summary[language].forbidden}{summary[language].licensingCount?"/"+summary[language].licensingCount:""} {summary[language].violationExclusions>0?<i className='opaque'>{"("+summary[language].violationExclusions+" excluded)"}</i>:""}</li>
                                <li>With license not found: {summary[language].undeclared}{summary[language].licensingCount?"/"+summary[language].licensingCount:""} {summary[language].warningExclusions>0?<i className='opaque'>{"("+summary[language].warningExclusions+" excluded)"}</i>:""}</li>
                            </React.Fragment>
                            :""
                        }
                    </ul>
                    <ul className="d-block d-sm-none" style={{listStyleType: "none"}}>
                        <li className="mb-2">
                            {summary[language].components>0?<span className="mr-3" title="Total components"><i className="fas fa-cubes fa-lg mr-1" style={{color: "var(--color-primary-1)"}}></i> {summary[language].components}</span>:""}
                            {   summary[language].vulnerable?<span className="mr-3" title="Vulnerable components"><i className="fas fa-bug fa-lg mr-1" style={{color: "var(--color-accents-reds-4)"}}></i>{summary[language].vulnerable}{summary[language].securityCount?"/"+summary[language].securityCount:""} {summary[language].securityExclusions>0?<i className='opaque'>{"("+summary[language].securityExclusions+" excluded)"}</i>:""}</span>:""}
                            {   summary[language].outdated?<span className="mr-3" title="Outdated components"><i className="fas fa-sync fa-lg mr-1" style={{color: "orange"}}></i> {summary[language].outdated}{summary[language].stabilityCount?"/"+summary[language].stabilityCount:""} {summary[language].stabilityExclusions>0?<i className='opaque'>{"("+summary[language].stabilityExclusions+" excluded)"}</i>:""}</span>:""}
                        </li>
                        <li className="mb-2">
                            <span className="mr-3" title="Components declaring a forbidden license"><i className="fas fa-gavel fa-lg mr-1" style={{color: "var(--color-accents-reds-4)"}}></i> {summary[language].forbidden}{summary[language].licensingCount?"/"+summary[language].licensingCount:""}</span>
                            <span className="mr-3 position-relative" title="Components with license not found"><i className="fas fa-exclamation mr-1 position-absolute fa-lg" style={{color: "orange", left:"var(--text-md)", top: "2px"}}></i><i className="fas fa-scroll fa-lg mr-1" style={{color:"var(--color-greys-2)"}}></i> {summary[language].undeclared}{summary[language].licensingCount?"/"+summary[language].licensingCount:""} </span> {summary[language].licensingExclusions>0?"("+summary[language].licensingExclusions+" excluded)":""}
                        </li>
                    </ul>
                            
                              
                </React.Fragment>
            )
        })

    }

	const {live}=urlParams;
    const {month, dayOfMonth, year, hour, minute, second} =timestamp;
    const processedSummary = processSummary(summary);
	return(
        display?
		<div className="col-lg-4" id="right-sidebar">
            <div id="right-sidebar-inner">
            <div className="report-box first">
		        <div className="report-box-header">
		          Report Details
		        </div>
		        <div className="report-box-text">
                    <b>Analysis scopes:</b> <br/>
                    <ul>
                        <li> Security: {scopesTranlsation[scopes.security]}</li>
                        <li> Stability: {scopesTranlsation[scopes.stability]}</li>
                        <li> Licensing: {scopesTranlsation[scopes.licensing]}</li>
                    </ul>
		            <table className="table">
		              <tbody>
		                <tr>
		                  <th scope="row">Generated on:</th>
		                  <td>{window.capitalize(month.toLowerCase())} {dayOfMonth}<small><sup>{selectOrdinalIndicator(dayOfMonth)}</sup></small> {year} at {getTimeString(hour,minute,second)} UTC</td>
		                </tr>
		              </tbody>
		            </table>
                    <Summary summary={processedSummary} />
		        </div>
		      </div>
            </div>
            {live?<button id="delete-report-button" className="pointer btn btn-primary btn-xxl" data-toggle="modal" data-target="#delete-report-modal"><span>Request to Delete</span></button>:null}
        </div>
        :null
	)
}







export {Actions, SideBar}